/* BCF C2 buy box: length selector, single/stack offer card, form fields.
   Markup and data: snippets/bcf-c2-offer.liquid.

   Cart submission is NOT done here. The form is a native /cart/add product form
   inside a .bcf ancestor, so the live bcf-cart.js intercepts it unchanged (AJAX
   add, one-add-on guard, cart drawer). This file only keeps the form's fields in
   the live selectors' protocol and the C2 copy in sync:
   - single: id + quantity (+ Rope: properties[_bcf_offer]=single, [Rope]);
   - stack:  items[0] main + items[1] Rope 040, _bcf_offer=subtle-addon,
             _bcf_role=main/addon (+ Rope: [Rope], [Length]; Curb/Figaro:
             items[1][Length]), plus items[0][properties][_care_kit]=included.
   Prices come from Shopify (variant prices, native automatic discounts).

   Stack modes (D.mode): "main" (this page + the Subtle Rope 040 add-on) and
   "subtle" (this page is the 040: Balanced Rope 050 is the main line, this
   page's variant the add-on). Both build their lines with stackFields().

   Emits on document: bcf:variant-change {variant:{id}} and
   bcf:c2-offer-change {stack, totalCents}. A length tap asks the gallery to
   show its fit slide at that length (bcf:c2-gallery-show {index, scroll, len}). Writes
   ?variant=, ?offer= and ?040= (main mode) or ?050= (subtle mode).
   Pure helpers are exported as BCFC2Offer (unit tests: scripts/c2-offer.test.mjs). */
(function (glob) {
  const LENS = [18, 20, 22, 24];
  const money = (c) => '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100));
  // The automatic discount's add-on price (Liquid: cents | times: keep | divided_by: 100.0 | round).
  const addonCents = (cents, pct) => Math.round(cents * ((100 - pct) / 100));
  const stackTotal = (mainCents, addonFullCents, pct) => mainCents + addonCents(addonFullCents, pct);

  // The two stack lines for the page state. main/addon: {v: variant|undefined, name, len}.
  function stackParts(D, len, otherLen) {
    const own = ((D.widths || []).find((w) => w.code === D.code) || { variants: {} }).variants[String(len)];
    if (D.mode === 'subtle') return { main: { v: (D.partner || {})[String(otherLen)], name: D.partnerName, len: otherLen }, addon: { v: own, name: D.name, len } };
    return { main: { v: own, name: D.name, len }, addon: { v: (D.addon || {})[String(otherLen)], name: D.addonName, len: otherLen } };
  }

  // Form fields for a stack, in the live selectors' protocol (same order as the Liquid first paint).
  function stackFields(rope, main, addon) {
    const f = [
      ['items[0][id]', main.id], ['items[0][quantity]', 1],
      ['items[0][properties][_bcf_offer]', 'subtle-addon'], ['items[0][properties][_bcf_role]', 'main'],
      ['items[0][properties][_care_kit]', 'included'],
    ];
    if (rope) f.push(['items[0][properties][Rope]', main.name], ['items[0][properties][Length]', main.len + ' inches']);
    f.push(['items[1][id]', addon.id], ['items[1][quantity]', 1],
      ['items[1][properties][_bcf_offer]', 'subtle-addon'], ['items[1][properties][_bcf_role]', 'addon']);
    if (rope) f.push(['items[1][properties][Rope]', addon.name]);
    f.push(['items[1][properties][Length]', addon.len + ' inches']);
    return f.map(([k, v]) => [k, String(v)]);
  }

  glob.BCFC2Offer = { LENS, money, addonCents, stackTotal, stackParts, stackFields };
  if (!glob.document) return;

  function init(buy) {
    if (buy.dataset.c2Ready) return;
    let D;
    try { D = JSON.parse(buy.querySelector('[data-c2-offer-data]').textContent); } catch (e) { return; }
    const form = buy.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    buy.dataset.c2Ready = '1';
    const root = buy.closest('[data-c2-pdp]') || document.documentElement;
    const $ = (s, el = buy) => el.querySelector(s);
    const $$ = (s, el = buy) => Array.from(el.querySelectorAll(s));
    const width = D.widths.find((w) => w.code === D.code) || { variants: {} };
    const subtle = D.mode === 'subtle';
    const stackable = subtle || (!!D.eligible && D.mode !== 'none');
    const mainAt = (n) => width.variants[String(n)];
    // The stack's other chain: the Subtle add-on (main mode) or the Balanced main (subtle mode).
    const other = (subtle ? D.partner : D.addon) || {};
    const otherAt = (n) => other[String(n)];
    const otherParam = subtle ? D.partnerParam || '050' : '040';
    const otherName = subtle ? D.partnerName : 'Subtle Rope';
    const addonPrice = (v) => addonCents(v.cents, D.pct);
    const stackTotal_ = (mainCents, addonFull) => stackTotal(mainCents, addonFull, D.pct);
    const strike = (c) => (D.anchorPct > 0 && D.anchorPct < 100 ? Math.round(c / 100 / (1 - D.anchorPct / 100)) * 100 : 0);

    const q = new URLSearchParams(location.search);
    const idOf = (v) => (v ? String(v.id) : '');
    const lenOfId = (id) => LENS.find((n) => idOf(mainAt(n)) === String(id));
    let len = lenOfId(root.dataset.c2VariantId) || 20;
    if (!q.get('variant') && LENS.includes(Number(q.get('length'))) && mainAt(q.get('length'))?.available) len = Number(q.get('length'));
    // Other-chain start length. Main mode: ?040= if available, else 18″, else the
    // first available 20/22/24. Subtle mode: ?050= if available, else 20″. Both
    // are the Liquid rule; with the other chain unavailable the stack can't start.
    const firstOther = subtle ? 20 : LENS.find((n) => otherAt(n)?.available) || 18;
    let otherLen = otherAt(q.get(otherParam))?.available ? Number(q.get(otherParam)) : firstOther;
    const wantStack = q.get('offer') === 'pair' ? true : q.get('offer') === 'single' ? false : D.defaultOffer !== 'single';
    let stack = stackable && wantStack && !!otherAt(otherLen)?.available && !!mainAt(len)?.available;
    let busy = false;
    let lastVariant = null;

    const stackValid = () => !!(mainAt(len)?.available && otherAt(otherLen)?.available);
    // m: this page's variant; o: the other chain; sm/sa: the stack's main/add-on line variants.
    const totals = () => {
      const m = mainAt(len), o = otherAt(otherLen);
      const p = stackParts(D, len, otherLen), sm = p.main.v, sa = p.addon.v;
      const single = m ? m.cents : 0;
      const stackTotal = sm && sa ? stackTotal_(sm.cents, sa.cents) : single;
      const stackStrike = sm && sa ? (subtle ? sm.cents + sa.cents : (strike(single) || single) + sa.cents) : 0;
      return { m, o, p, single, stackTotal, stackStrike, total: stack ? stackTotal : single };
    };

    function put(name, value) {
      const i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = String(value); i.dataset.c2Input = '';
      form.appendChild(i);
    }

    function syncForm() {
      const { m, p } = totals();
      const id = form.querySelector('input[name="id"]');
      const qty = form.querySelector('input[name="quantity"]');
      $$('[data-c2-input]', form).forEach((n) => n.remove());
      if (id) {
        id.disabled = stack;
        if (id.value !== idOf(m)) {
          id.value = idOf(m);
          // Shop Pay installments (shopify-payment-terms) follow the form's id input.
          id.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const terms = form.querySelector('shopify-payment-terms');
      if (terms && m && terms.getAttribute('variant-id') !== idOf(m)) terms.setAttribute('variant-id', idOf(m));
      if (qty) { qty.value = '1'; qty.disabled = stack; }
      const rope = D.family === 'rope';
      if (stack) {
        stackFields(rope, { id: idOf(p.main.v), name: p.main.name, len: p.main.len }, { id: idOf(p.addon.v), name: p.addon.name, len: p.addon.len })
          .forEach(([k, v]) => put(k, v));
      } else if (rope) {
        put('properties[_bcf_offer]', 'single'); put('properties[Rope]', D.name);
      }
      const valid = stack ? stackValid() : !!m?.available;
      form.dataset.bcfOffer = stack ? 'pair' : 'single';
      form.dataset.bcfSelectionValid = String(valid);
      return valid;
    }

    function setText(sel, text, el = buy) { const n = $(sel, el); if (n && n.textContent !== text) n.textContent = text; }

    function renderTitle(m) {
      if (!m || !root.querySelector) return;
      root.dataset.c2VariantId = idOf(m);
      root.dataset.c2PriceCents = String(m.cents);
      const price = root.querySelector('[data-c2-price]');
      if (price) price.innerHTML = '<span class="visually-hidden">Sale price</span>' + money(m.cents);
      const s = strike(m.cents);
      const was = root.querySelector('[data-c2-strike]'), save = root.querySelector('[data-c2-save]');
      if (was) { was.innerHTML = '<span class="visually-hidden">Regular price</span>' + money(s); was.hidden = !(s > m.cents); }
      if (save) { save.textContent = 'Save ' + money(s - m.cents); save.hidden = !(s > m.cents); }
    }

    function syncUrlAndLinks(m) {
      try {
        const u = new URL(location.href);
        if (m) u.searchParams.set('variant', idOf(m));
        for (const k of ['width', 'length', 'singleWidth', 'singleLength']) u.searchParams.delete(k);
        if (stackable) { u.searchParams.set('offer', stack ? 'pair' : 'single'); u.searchParams.set(otherParam, String(otherLen)); }
        if (u.href !== location.href) history.replaceState(history.state, '', u);
        $$('[data-c2-width-chip]').forEach((a) => {
          const w = D.widths.find((x) => x.code === a.dataset.c2WidthChip);
          if (!w || !w.url || a.tagName !== 'A') return;
          const pick = w.variants[String(len)]?.available ? w.variants[String(len)] : w.variants['20']?.available ? w.variants['20'] : LENS.map((n) => w.variants[String(n)]).find((v) => v && v.available) || w.variants[String(len)];
          const t = new URL(w.url, location.origin);
          u.searchParams.forEach((v, k) => t.searchParams.set(k, v));
          t.searchParams.set('view', 'c2');
          if (pick) t.searchParams.set('variant', idOf(pick)); else t.searchParams.delete('variant');
          a.href = t.pathname + t.search;
        });
        const fit = $('[data-c2-fit-guide]');
        if (fit) { const f = new URL(fit.getAttribute('href'), location.origin); f.searchParams.set('length', String(len)); fit.href = f.pathname + f.search; }
      } catch (e) { /* URL APIs unavailable: links keep their server-rendered hrefs */ }
    }

    function render() {
      const { m, o, single, stackTotal, stackStrike, total } = totals();
      const valid = syncForm();

      // Selectors.
      $$('[data-c2-length]').forEach((b) => {
        const n = Number(b.dataset.c2Length);
        b.setAttribute('aria-pressed', String(n === len));
        b.disabled = busy || !mainAt(n)?.available;
      });
      if (m) setText('[data-c2-weight]', `${m.grams} g at ${len}″`);

      // Offer card.
      if (stackable) {
        $$('[data-c2-pick]').forEach((b) => { b.setAttribute('aria-pressed', String((b.dataset.c2Pick === 'stack') === stack)); b.disabled = busy; });
        const card = $('[data-c2-stack-card]');
        if (card) card.classList.toggle('is-on', stack);
        $('[data-c2-pick="single"]')?.classList.toggle('is-on', !stack);
        if (o && !subtle) setText('[data-c2-offer-title]', 'Add a second silver chain for ' + money(addonPrice(o)));
        setText('[data-c2-single-price]', money(single));
        const ss = $('[data-c2-single-strike]'), s1 = strike(single);
        if (ss) { ss.textContent = money(s1); ss.hidden = !(s1 > single); }
        setText('[data-c2-single-sub]', `${D.name} · ${len}″ · +$6 shipping`);
        setText('[data-c2-stack-price]', money(stackTotal));
        if (stackStrike) setText('[data-c2-stack-strike]', money(stackStrike));
        setText('[data-c2-addon-len]', String(otherLen));
        $$('[data-c2-addon-length]').forEach((b) => {
          const n = Number(b.dataset.c2AddonLength);
          b.setAttribute('aria-pressed', String(n === otherLen));
          b.disabled = busy || !otherAt(n)?.available;
        });
        const gift = $('[data-c2-gift]');
        if (gift) gift.classList.toggle('is-locked', !stack);
        setText('[data-c2-gift-title]', stack ? 'Free with your stack' : 'Choose the stack to unlock');
      }

      // CTA.
      const cta = $('[data-c2-cta]');
      const label = !m?.available ? 'Sold out'
        : stack && !o?.available ? `${otherName} ${otherLen}″ is sold out`
        : stack ? `Add 2 chains — ${money(stackTotal)}` : `Add 1 chain — ${money(single)}`;
      if (!busy) setText('[data-c2-cta-label]', label);
      if (cta) cta.disabled = busy || !valid;
      const err = $('#selection-error');
      if (err && !busy) {
        const msg = stack && m?.available && !o?.available ? `The ${otherName} at ${otherLen}″ is sold out. Choose another length or 1 chain.` : '';
        if (msg || err.dataset.c2Owned) { err.textContent = msg; err.hidden = !msg; err.dataset.c2Owned = msg ? '1' : ''; }
      }
      if (stack && o && !o.available) {
        const list = $('[data-c2-addon-lengths]'), btn = $('[data-c2-addon-change]');
        if (list) list.hidden = false;
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }

      renderTitle(m);
      syncUrlAndLinks(m);
      if (m && idOf(m) !== lastVariant) {
        lastVariant = idOf(m);
        document.dispatchEvent(new CustomEvent('bcf:variant-change', { detail: { variant: { id: m.id, inches: String(len), price: m.cents } } }));
      }
      document.dispatchEvent(new CustomEvent('bcf:c2-offer-change', { detail: { stack, totalCents: total } }));
    }

    buy.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-c2-length],button[data-c2-pick],button[data-c2-addon-length],button[data-c2-addon-change]');
      if (!b || !buy.contains(b)) return;
      if (busy) { e.preventDefault(); return; }
      // Any selection change clears a stale bcf-cart.js notice (e.g. "already in your bag").
      const err = $('#selection-error');
      if (err && !err.dataset.c2Owned) { err.textContent = ''; err.hidden = true; }
      if (b.dataset.c2Length) { const n = Number(b.dataset.c2Length); if (!mainAt(n)?.available) return; len = n; showFitSlide(); }
      else if (b.dataset.c2Pick) { if (!stackable) return; stack = b.dataset.c2Pick === 'stack'; }
      else if (b.dataset.c2AddonLength) { const n = Number(b.dataset.c2AddonLength); if (!otherAt(n)?.available) return; otherLen = n; stack = true; }
      else if (b.hasAttribute('data-c2-addon-change')) {
        const list = $('[data-c2-addon-lengths]'), open = list.hidden;
        list.hidden = !open; b.setAttribute('aria-expanded', String(open));
        if (open) stack = true; else { render(); return; }
      }
      render();
    });

    // A width chip is a link to the sibling product; block it only while adding.
    buy.addEventListener('click', (e) => { if (busy && e.target.closest('[data-c2-width-chip]')) e.preventDefault(); }, true);

    // The gallery's fit slide (BCFC2Gallery.fitSlideIndex) at the selected length,
    // shown via bcf:c2-gallery-show; the gallery scrolls itself into view only
    // when its frame is off screen. No fit data (or product-media gallery): nothing happens.
    function showFitSlide() {
      const G = glob.BCFC2Gallery, q = (s) => root.querySelector && root.querySelector(s);
      const gd = q('#bcf-c2-gallery-data'), fd = q('#bcf-c2-fit-data');
      if (!G || !gd || !fd) return false;
      let data, fit;
      try { data = JSON.parse(gd.textContent); fit = JSON.parse(fd.textContent); } catch (e) { return false; }
      const index = G.fitSlideIndex(data, fit);
      if (index < 0) return false;
      buy.dispatchEvent(new CustomEvent('bcf:c2-gallery-show', { bubbles: true, detail: { index, scroll: true, len: String(len) } }));
      return true;
    }
    // "View fit guide": the fit slide when there is one, else the chain finder page.
    $('[data-c2-fit-guide]')?.addEventListener('click', (e) => { if (showFitSlide()) e.preventDefault(); });

    // bcf-cart.js reports its add lifecycle; lock the selection while it runs.
    document.addEventListener('bcf:cart-add-state', (e) => {
      if (!e.detail || e.detail.formId !== form.id) return;
      busy = !!e.detail.busy;
      if (busy) setText('[data-c2-cta-label]', 'Adding…');
      render();
    });
    // Re-sync right before submit so the posted fields always match the UI.
    form.addEventListener('submit', () => { if (!busy) syncForm(); }, true);

    window.addEventListener('popstate', () => {
      const p = new URLSearchParams(location.search);
      const n = lenOfId(p.get('variant'));
      if (n) len = n;
      if (stackable && p.get('offer')) stack = p.get('offer') === 'pair';
      const a = Number(p.get(otherParam));
      if (stackable && LENS.includes(a) && otherAt(a)?.available) otherLen = a;
      render();
    });

    render();
  }

  const boot = () => document.querySelectorAll('[data-c2-buy]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : globalThis);
